import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  width: var(--size, 100px);
  height: var(--size, 100px);
  transform-style: preserve-3d;
  transition: transform 500ms;
  transition-timing-function: ease-in-out;

  &.show-1 {
    transform: rotateX(720deg) rotateZ(-720deg);
  }

  &.show-6 {
    transform: rotateX(-900deg) rotateZ(1080deg);
  }

  &.show-3 {
    transform: rotateY(-450deg) rotateZ(-1440deg);
  }

  &.show-4 {
    transform: rotateY(810deg) rotateZ(720deg);
  }

  &.show-5 {
    transform: rotateX(-810deg) rotateZ(-1080deg);
  }

  &.show-2 {
    transform: rotateX(450deg) rotateZ(-720deg);
  }
`;

const Side = styled.div<{ image: string }>`
  position: absolute;
  background-color: #fff;
  background-image: url("${({ image }) => image}");
  background-size: cover;
  border-radius: var(--radius, 5px);
  width: var(--size, 100px);
  height: var(--size, 100px);
  border: 1px solid #e5e5e5;
  text-align: center;
  line-height: var(--size, 100px);

  &:nth-child(1) {
    transform: translateZ(calc(var(--size, 100px) / 2));
  }

  &:nth-child(6) {
    transform: rotateY(90deg) translateZ(calc(var(--size, 100px) / 2));
  }

  &:nth-child(3) {
    transform: rotateY(-90deg) translateZ(calc(var(--size, 100px) / 2));
  }

  &:nth-child(4) {
    transform: rotateX(90deg) translateZ(calc(var(--size, 100px) / 2));
  }

  &:nth-child(5) {
    transform: rotateX(-90deg) translateZ(calc(var(--size, 100px) / 2));
  }

  &:nth-child(2) {
    transform: rotateY(-180deg) translateZ(calc(var(--size, 100px) / 2));
  }
`;

const Dice = forwardRef((props: { hide?: boolean }, ref) => {
  const [show, setShow] = useState<number>();
  const [faces, setFaces] = useState([
    "/assets/dice/tank.png",
    "/assets/dice/infantery.png",
    "/assets/dice/star.png",
    "/assets/dice/grenade.png",
    "/assets/dice/infantery.png",
    "/assets/dice/star.png",
  ]);

  const onRoll = useCallback(() => {
    const newShow = Math.floor(Math.random() * 6) + 1; // 1-6
    console.log(`New show ${newShow} and ${show}`);
    if (newShow === show) {
      // we should force to change to activate the animation
      const tweakedNewShow = show === 6 ? 1 : show + 1;
      // we should swap faces
      const newFaces = [...faces];
      const replacedFace = newFaces[tweakedNewShow - 1];
      newFaces[tweakedNewShow - 1] = newFaces[show - 1];
      setFaces(newFaces);
      setTimeout(() => {
        newFaces[show] = replacedFace;
        setFaces([...newFaces]);
      }, 600);
      setShow(tweakedNewShow);
    } else {
      setShow(newShow);
    }
  }, [show, faces]);

  useImperativeHandle(
    ref,
    () => ({
      roll: onRoll,
    }),
    [onRoll]
  );

  //console.log(faces);

  return (
    <Container
      style={{
        display: props.hide ? "none" : "block",
      }}
      className={show !== undefined ? `show-${show}` : undefined}
    >
      <Side image={faces[0]}></Side>
      <Side image={faces[1]}></Side>
      <Side image={faces[2]}></Side>
      <Side image={faces[3]}></Side>
      <Side image={faces[4]}></Side>
      <Side image={faces[5]}></Side>
    </Container>
  );
});

export default Dice;
